<template>
  <div class="books-details">
    <!-- 顶部大图片 -->
    <imgBigCards></imgBigCards>
    <!-- 输入框 -->
    <div class="box-input">
      <inputBox
        @query="inputBoxClick"
        placeholder="请输入内容"
        v-model:inputValue="mydata.form.search"
      ></inputBox>
    </div>

    <!--模块1  -->
    <div class="box-studentWorld1">
      <!-- 知识干货 -->
      <column title="知识干货" path="/layout/list/KnowledgeDrivenGoods">
        <template #abc>
          <ul>
            <li
              v-for="(item, index) in mydata.articleListArr1"
              :key="index"
              @click="detailsOneButton(item.id)"
              class="my-li hover-change-color"
            >
              <p>{{ item.title }}</p>
              <p>{{ dayjs(item.release_time * 1000).format("YYYY-MM-DD") }}</p>
            </li>
          </ul>
        </template>
      </column>
      <!-- 作品展示 -->
      <column title="作品展示" path="/layout/list/worksDisplay">
        <template #abc>
          <ul>
            <li
              v-for="(item, index) in mydata.articleListArr2"
              :key="index"
              @click="detailsFourButton(item.id)"
              class="my-li hover-change-color"
            >
              <p>{{ item.title }}</p>
              <p>{{ dayjs(item.release_time * 1000).format("YYYY-MM-DD") }}</p>
            </li>
          </ul>
        </template>
      </column>
    </div>
    <!--模块2——————专题活动  -->
    <div class="box-studentWorld2">
      <column title="专题活动" path="/layout/list/thematicActivities">
        <template #abc>
          <!-- 轮播图图片组件 -->
          <swiperImg2
            :dataArr="mydata.articleListArr3"
            @itemClick="swiperItemClick"
            :key="mydata.testKey"
          ></swiperImg2>
        </template>
      </column>
    </div>

    <!--模块3——————在线学习 -->
    <div class="box-studentWorld3">
      <column title="在线学习" path="/layout/list/onlineLearning">
        <template #abc>
          <div class="box-tag">
            <el-tag
              style="cursor: pointer"
              v-for="item in mydata.items"
              :key="item.label"
              effect="plain"
              @click="tagItemClick(item.id)"
              :class="item.id === mydata.tagActive ? 'el-tag-active' : ''"
            >
              {{ item.label }}
            </el-tag>
          </div>
          <div class="content-online">
            <swiperImg3
              :dataArr="mydata.articleListArr4"
              @itemClick="swiperItemClick2"
              :key="mydata.testKey2"
            >
             
            </swiperImg3>

            <!-- <researchProjects
              :path="mydata.online_path"
              v-for="(item, index) in mydata.articleListArr4"
              :key="index"
              :info="item"
              :showBoxShadow="false"
            >
              <template #img>
                <img
                  v-complete:src="item.image"
                  alt=""
                  width="343px"
                  height="201px"
                  style="cursor: pointer"
                />
              </template>
              <template #Button>
                <el-tag v-if="item.class_stage_text">{{
                  item.class_stage_text
                }}</el-tag>
                <el-tag v-if="item.classes_text">{{
                  item.classes_text
                }}</el-tag>
                <el-tag v-if="item.subject_text">{{
                  item.subject_text
                }}</el-tag>
                <el-tag v-for="(item, index) in item.tags" :key="index">{{
                  item.name
                }}</el-tag>
              </template>
            </researchProjects> -->
          </div>
        </template>
      </column>
    </div>
    <!--模块4—————— 用天利图书做经典试题-->
    <div class="box-studentWorld4">
      <img src="@/assets/qwer.png" alt="" />
      <!-- 轮播图图片组件 -->
      <swiperImg
        v-if="mydata.recommend_list.length"
        :dataArr="mydata.recommend_list"
        @itemClick="itemClick"
        :key="mydata.testKey5"
      ></swiperImg>
    </div>
  </div>
</template>

<script>
// 是否来自其他模块
let fromOtherModule = false;
// 缓存组件
import { defineComponent } from "vue";
export default defineComponent({
  name: "studentWorld",
  beforeRouteEnter(to, from, next) {
    // 如果不是来自详情页面，而是来自其他模块，那么就把fromOtherModule设置为true值
    if (
      [
        "/layout/list/studentWorldList",
        "/layout/list/KnowledgeDrivenGoods",
        "/layout/list/KnowledgeDetails",
        "/layout/list/worksDisplay",
        "/layout/list/worksDisplayDetails",
        "/layout/list/thematicActivities",
        "/layout/list/thematicDetails",
        "/layout/list/onlineLearning",
        "/layout/list/onlineDetails",
      ].includes(from.path) === false
    ) {
      fromOtherModule = true;
      // console.log('来自其他模块');
    }
    next();
  },
});
</script>









<script setup>
import swiperImg from "@/components/swiperImg/index.vue";
import swiperImg2 from "@/components/swiperImg2/index.vue";
import swiperImg3 from "@/components/swiperImg3/index.vue";

import { reactive, onActivated } from "vue";
import imgBigCards from "@/components/imgBigCards/index.vue";
import inputBox from "@/components/inputBox/index.vue";

import column from "@/components/column/index.vue";

import researchProjects from "@/components/researchProjects/index.vue";

import dayjs from "dayjs";
import { useRouter, useRoute } from "vue-router";

// 引入接口
import { articleList, onlineStudyClass } from "@/api/home/index.js";
// 引入接口
import { getUrlId } from "@/utils/slide.js";
// 引入接口
import { examSearchList } from "@/api/boutiqueTaobaoQuestions/listenBig/index.js";

// 推荐列表接口
import { getRecommendList } from "@/api/recommend/index.js";
import { dictKeyWord } from "@/utils/dict.js";

const router = useRouter();
const route = useRoute();

const mydata = reactive({
  // items: JSON.parse(localStorage.getItem("classes")) ?? [],
  items: [],
  // tagActive: JSON.parse(localStorage.getItem("classes"))[0].id ?? "",
  tagActive: "",

  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,

  testKey: new Date().getTime() - Math.random(),
  testKey2: new Date().getTime() - Math.random() * 100,

  testKey5: new Date().getTime() - Math.random() * 100000,

  articleListArr1: [], // 文章列表-知识干货
  articleListArr2: [], // 文章列表-作品展示
  articleListArr3: [], // 文章列表-专题活动
  articleListArr4: [], // 文章列表-在线学习

  knowledge_path: "/layout/list/KnowledgeDetails",
  works_path: "/layout/list/worksDisplayDetails",
  thematic_path: "/layout/list/thematicDetails", //专题活动
  online_path: "/layout/list/onlineDetails", //在线学习

  form: {
    // column_id: getUrlId(route.path), // 栏目id值
    search: "", // 搜索查询
    // stage: "", //学段
    // theme: "", //主题
    // subject: "", //学科
  },

  recommend_list: {}, //推荐列表
});

onActivated(() => {
  // // 如果是来自其他模块，那么就重置数据
  // if (fromOtherModule) {
  // 如果是来自其他模块，那么就重置数据。或者，第一次进入这个页面，那么就重置数据
  if (fromOtherModule || JSON.parse(localStorage.getItem('routerRecord'))[route.path] === 1) {
    mydata.items = [];
    // tagActive: JSON.parse(localStorage.getItem("classes"))[0].id ?? "",
    mydata.tagActive = "";

    // 基础地址
    mydata.VUE_APP_BASE_HOST = process.env.VUE_APP_BASE_HOST;

    mydata.articleListArr1 = []; // 文章列表-知识干货
    mydata.articleListArr2 = []; // 文章列表-作品展示
    mydata.articleListArr3 = []; // 文章列表-专题活动
    mydata.articleListArr4 = []; // 文章列表-在线学习

    mydata.knowledge_path = "/layout/list/KnowledgeDetails";
    mydata.works_path = "/layout/list/worksDisplayDetails";
    mydata.thematic_path = "/layout/list/thematicDetails"; //专题活动
    mydata.online_path = "/layout/list/onlineDetails"; //在线学习

    mydata.form = {
      // column_id: getUrlId(route.path), // 栏目id值
      search: "", // 搜索查询
      // stage: "", //学段
      // theme: "", //主题
      // subject: "", //学科
    };

    mydata.recommend_list = {}; //推荐列表

    // 把原来的函数调用放到缓存组件钩子里面了，原来的函数调用注释了
    getBottomRecommendData();
    // 把原来的函数调用放到缓存组件钩子里面了，原来的函数调用注释了
    articleListFn();
  }
  // 重置fromOtherModule为false值，避免fromOtherModule一直是true值，不再动态变化
  fromOtherModule = false;

  if (localStorage.getItem("v") !== null) {
    // 分页变成第一页
    mydata.pageObj.currentPage = 1;
    mydata.form.search = localStorage.getItem("v"); // 获取本地存储并且赋值
    localStorage.removeItem("v"); // 赋值后立刻删除本地存储内容

    // 把原来的函数调用放到缓存组件钩子里面了，原来的函数调用注释了
    getBottomRecommendData();
    // 把原来的函数调用放到缓存组件钩子里面了，原来的函数调用注释了
    articleListFn();

    // 拿到query参数并且赋值之后，就进行二次跳转，把query参数删除了，避免详情页面后退到列表页面的时候，再次拿到query参数并且赋值
    // router.push({
    //   path:"/layout/list/addedServices"
    // })
  }

  // 注意：绑定给swiper轮播图的key变量，不要 写在if(fromOtherModule){}里面，而是写在它的外面，因为不管是不是其他模块跳转过来的还是自己模块后退过来的，都要重新赋值这个绑定给swiper的key变量
  mydata.testKey = new Date().getTime() - Math.random();
  mydata.testKey2 = new Date().getTime() - Math.random() * 100;

  mydata.testKey5 = new Date().getTime() - Math.random() * 100000;
});

onlineStudyClass().then((res) => {
  // console.log(1,res.data.classes);
  let obj = res.data.classes;
  let arr = [];
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const item = {
        name: Number(key),
        label: obj[key],
        id: Number(key),
      };
      arr.push(item);
    }
  }
  mydata.items = arr;
  mydata.tagActive = arr[0].id;
});

function itemClick(val) {
  let path = val.buy_url_jd || val.buy_url;
  if (path) {
    window.open(path);
  }
}

function tagItemClick(id) {
  mydata.tagActive = id;
  fn4();
}

// 获取文章列表
function articleListFn() {
  fn1();
  fn2();
  fn3();
  fn4();
}

// 知识干货
function fn1() {
  articleList({
    ...mydata.form,
    column_id: getUrlId("/layout/list/KnowledgeDrivenGoods"),
    page: 1,
    psize: 5,
  }).then((res) => {
    mydata.articleListArr1 = res.data.list.map((item) => {
      item.img_url = mydata.VUE_APP_BASE_HOST + item.image;
      item.img_txt = item.title;
      return item;
    });
  });
}
// 作品展示
function fn2() {
  articleList({
    ...mydata.form,
    column_id: getUrlId("/layout/list/worksDisplay"),
    page: 1,
    psize: 5,
  }).then((res) => {
    mydata.articleListArr2 = res.data.list.map((item) => {
      item.img_url = mydata.VUE_APP_BASE_HOST + item.image;
      item.img_txt = item.title;
      return item;
    });
  });
}
// 专题活动
function fn3() {
  articleList({
    ...mydata.form,
    column_id: getUrlId("/layout/list/thematicActivities"),
    page: 1,
    psize: 6,
  }).then((res) => {
    mydata.articleListArr3 = res.data.list.map((item) => {
      // item.img_url = mydata.VUE_APP_BASE_HOST + item.image;
      item.img_url = item.image;
      item.img_txt = item.title;
      return item;
    });
  });
}
// 在线学习
function fn4() {
  articleList({
    ...mydata.form,
    column_id: getUrlId("/layout/list/onlineLearning"),
    page: 1,
    psize: 6,
    classes: mydata.tagActive,
  }).then((res) => {
    mydata.articleListArr4 = res.data.list.map((item) => {
      item.img_url = mydata.VUE_APP_BASE_HOST + item.image;
      item.img_txt = item.title;
      // console.log(item, "在线学习");
      return item;
    });
  });
}

// 查询列表
// function queryList(dict, inputValue) {
//   // 赋值
//   mydata.form.search = inputValue;

//   // 获取页面数据
//   // articleListFn();
// }

function inputBoxClick(type, value) {
  // 分页变成第一页
  // mydata.pageObj.currentPage = 1
  // 赋值
  mydata.form.search = value;
  router.push({
    path: "/layout/list/studentWorldList",
    query: {
      search: value,
    },
  });
}

// 调用函数
// articleListFn();

//点击事件1——————知识干货
function detailsOneButton(id) {
  router.push({
    path: mydata.knowledge_path,
    query: { id },
  });
}

//点击事件2——————作品展示
function detailsFourButton(id) {
  router.push({
    path: mydata.works_path,
    query: { id },
  });
}

function swiperItemClick(val) {
  router.push({
    path: mydata.thematic_path,
    query: { id: val.id },
  });
}

function swiperItemClick2(val) {
  router.push({
    path: mydata.online_path,
    query: { id: val.id },
  });
}

// 底部推荐数据
function getBottomRecommendData() {
  // // 调用接口
  // examSearchList({
  //   search: "", // 搜索查询
  //   grade_id: "", // 年级
  //   subject_id: "", //学科
  //   address_id: "", //地区
  //   type_id: "", //类型
  //   year_id: "", // 年份
  //   is_new: "", //是否最新（不传或者传0：否，1：是）
  //   is_recommended: "1", //是否推荐（不传或者传0：否，1：是）
  // }).then((res) => {
  //   mydata.recommend_list = res.data.list;

  // });

  // 使用标题在字典中进行匹配，得到对应的keyword值
  let keyword = dictKeyWord["必备好书"];
  getRecommendList({
    keyword: keyword,
    page: 1,
    psize: 10,
    column_key: route.path,
  }).then((res) => {
    mydata.recommend_list = res.data.list;
  });
}
// getBottomRecommendData();

function liClick(id) {
  router.push({
    path: "/layout/list/topicSubjectDetails",
    query: { id },
  });
}
</script>

<style scoped lang="scss">
.my-li {
  > p {
    cursor: pointer;
    // border: 1px solid red;
  }
  > p:nth-of-type(1) {
    width: calc(100% - 100px);
    position: static !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
// .box-studentWorld1 {
//   .my-li {
//     > p:nth-of-type(1) {
//       width: 100%;
//     }
//   }
// }

li:hover {
  p:nth-of-type(2) {
    color: #009de0;
  }
}

////////整体设置column组件
:deep(.box-column) {
  // padding: 30px;
  ////

  .column-title {
    font-size: 18px;
    font-weight: 700;
    color: #333333;
    border-bottom: 1px solid #cccccc;
  }
  .column-content {
    height: 160px;
    // border:1px solid red;
    overflow: hidden;
    li:hover {
      p:nth-of-type(2) {
        color: #009de0;
      }
    }

    li {
      margin-left: 20px;
      // display: flex;
      // justify-content: space-between;
      // align-items: center;
      margin-bottom: 10px;
      // border: 1px solid red;
      position: relative;
      p:first-of-type {
        font-size: 14px;
        margin-bottom: 10px;
        line-height: 24px;
        white-space: nowrap; //不折行
        text-overflow: ellipsis; //文本溢出 用省略号显示
        overflow: hidden;
      }
      p:nth-of-type(2) {
        font-size: 14px;
        font-weight: 400;
        color: #888888;
        position: absolute;
        right: 0px;
        top: 2px;
      }
    }
    li:nth-last-of-type(1) {
      margin-bottom: 0px;
    }
  }
}

.books-details {
  background-color: #f9f9f9;
  overflow: hidden;
  // border: 1px solid red;
  padding-bottom: 40px; //距离bottomBar的距离

  ////////顶部大图片
  // > .big-img {
  //   width: 100%;
  //   height: 200px;
  //   // border:1px solid rgb(68, 0, 255);
  //   margin: 0 auto;
  // }
  // :deep(.box-img) {
  //   height: 200px;
  // }
  // //el-carousel元素
  // :deep(.el-carousel__container) {
  //   width: 100%;
  //   height: 200px;
  //   // padding:30px;
  // }

  ///////输入框
  .box-input {
    width: 100%;
    // height: 100px;
    //   // border: 1px solid red;
    background-color: #ffffff;
    // border:1px solid red;
    padding: 10px 0px;
    margin-bottom: 16px;
    :deep(.inputBox) {
      margin: 0 auto;
      display: block;
      // border:1px solid red;
      .box2 {
        display: none;
      }
    }
  }

  ///////知识干货————作品展示------
  .box-studentWorld1 {
    // border: 1px solid rgb(85, 0, 255);
    margin: 0 auto;
    margin-top: 16px;
    // margin-bottom: 16px;
    overflow: hidden;
    :deep(.box-column) {
      height: 100%;
      margin-bottom: 16px;
      // border:1px solid red;
      background: linear-gradient(
        180deg,
        #dff5ff 0%,
        rgba(255, 255, 255, 0.2) 145px,
        #ffffff 100%
      );
    }

    :deep(.box-column):nth-of-type(2) {
      background: linear-gradient(
        180deg,
        #fdeff1 0%,
        rgba(255, 255, 255, 0.2) 145px,
        #ffffff 100%
      );
    }
  }

  ///////专题活动------
  .box-studentWorld2 {
    margin-bottom: 16px;
    // border: 1px solid red;
    :deep(.book-cards.column-book1) {
      // border: 1px solid red;
      // width:387px;
      // height:281px;
      height: auto !important;
      .box-content {
        > p {
          height: 48px;
          line-height: 24px;
          display: -webkit-box;
          -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
          text-overflow: ellipsis; //文本溢出 用省略号显示
          -webkit-line-clamp: 2; //几行
          overflow: hidden;
        }
      }
    }
    // width: 1200px;
    // height: 455px;
    // margin: 0 auto;
    // overflow: hidden;
    // border-radius: 8px;
    // border:1px solid red;

    // //图片宽高
    // :deep(.swiper-slide.book-cards) {
    //   width: 410px !important;
    //   // border:1px solid red;
    // }
    // :deep(.book-cards.column-book1) {
    //   width: 387px !important;
    //   .big-img {
    //     // width:387px !important;
    //     height: 218px !important;
    //     // border:1px solid red;
    //   }
    // }

    :deep(.box-column) {
      overflow: visible !important;

      // width: px;
      // height: 100%;
      margin: 0 auto;
      // border: 1px solid red;
      background-color: #ffffff;
      box-shadow: none;
      // padding: 30px 0 !important;
    }
    :deep(.column-title) {
      border-bottom: none !important;
    }
    :deep(.column-content) {
      overflow: visible !important;
      display: flex;
      flex-shrink: 0;
      height: 265px;
    }

    :deep(.swiper.swiper-initialized.swiper-horizontal.inside-cardBox) {
      // border:1px solid rgb(0, 0, 255);
      // height: 165px;
      .swiper-slide.book-cards {
        p {
          width: 343px;
          margin-top: 10px;
        }
      }
    }
  }

  ///////模块3------
  .box-studentWorld3 {
    // width: 1200px;
    // height: 808px;
    margin: 0 auto;
    overflow: hidden;
    margin-bottom: 16px;
    :deep(.box-column) {
      margin: 0 auto;
      // border: 1px solid red;
      // width: 1200px;
      height: 100%;
      padding-bottom: 16px;

      .column-content {
        height: auto;
      }

      .box-tag {
        display: flex;
        // justify-content: center;
        overflow-x: auto;

        /* 针对webkit内核浏览器 */
        ::-webkit-scrollbar {
          display: none; /* 隐藏滚动条 */
        }

        /* 针对Firefox */
        scrollbar-width: none; /* Firefox中隐藏滚动条 */

        /* 针对IE和Edge */
        -ms-overflow-style: none; /* IE和Edge中隐藏滚动条 */

        // :deep(.el-tag.el-tag--primary.el-tag--plain){
        //   margin-right:24px;
        //   border:1px solid red;

        // }
        .el-tag.el-tag--primary.el-tag--plain {
          display: inline-block;
          // width: 60px;
          height: 30px;
          margin: 0 10px;
          line-height: 28px;
          text-align: center;
          font-size: 16px;
          border-color: #d9d9d9cc;
          color: #333333;
          cursor: pointer;
          // border:1px solid red;
        }
        .el-tag.el-tag--primary.el-tag--plain.el-tag-active {
          background: #009de0;
          color: #ffffff;
        }
      }
      .content-online {
        // border: 1px solid blue;
        margin-top: 10px;
        // overflow: hidden;
        overflow: visible;
        // border:1px solid red;
      }
    }
  }

  ///////模块4------
  .box-studentWorld4 {
    // width: 1200px;
    // height: 462px;
    // border: 1px solid rgb(60, 255, 0);
    background: linear-gradient(
      180deg,
      #dcf5ff 0%,
      rgba(255, 255, 255, 0.2) 145px,
      #ffffff 100%
    );
    margin: 0 auto;
    // margin-bottom: 50px;
    // display: flex;
    // justify-content: space-between;
    // overflow: hidden;
    padding: 30px 0px 20px 0px;
    > img {
      width: 307px;
      height: 50px;
      // border:1px solid red;
      margin: 0 auto;
      margin-bottom: 30px;
      display: block;
    }
    .img-box {
      height: 270px;
      // border:1px solid blue;
      display: flex;
      justify-content: space-between;
      // margin-bottom:52px;
    }
  }

  ////////最顶部的title
  // .title-box {
  //   width: 1200px;
  //   margin: 0 auto;
  //   // border: 1px solid blue;
  //   margin-top: 50px;
  //   margin-bottom: 20px;
  //   .title {
  //     width: 860px;
  //     height: 24px;
  //     // border: 1px solid red;
  //     display: flex;
  //     justify-content: space-between;
  //     .title-left {
  //       // width:200px;
  //       // border:1px solid blue;
  //       display: flex;
  //       font-size: 14px;
  //       font-weight: 400;
  //       color: #bbbdbf;
  //       .line {
  //         margin: 0px 8px;
  //       }
  //       p:hover {
  //         color: #009de0;
  //       }
  //     }
  //     .title-right {
  //       // width:60px;
  //       font-size: 16px;
  //       font-weight: 400;
  //       color: #bbbdbf;
  //       display: flex;
  //       align-items: center;
  //       // position:relative;
  //       // border:1px solid blue;
  //       .el-icon {
  //         font-size: 24px;
  //         font-weight: 400;
  //         margin-right: 4px;
  //       }
  //     }
  //     .title-right:hover {
  //       color: #009de0;
  //     }
  //   }
  // }

  // //////内容部分
  // .box-content {
  //   width: 1200px;
  //   // border: 1px solid red;
  //   margin: 0 auto;
  //   margin-top: 21px;
  //   // margin-bottom:16px;
  //   display: flex;
  //   justify-content: space-between;
  // }
  // //////////column组件
  // :deep(.box-column) {
  //   > .column-title {
  //     font-size: 24px;
  //     font-weight: 700;
  //     color: #333333;
  //     border-bottom: 1px solid #cccccc;
  //     // border: 1px solid red;
  //     p {
  //       font-size: 16px;
  //       font-weight: 400;
  //       color: #999999;
  //     }
  //   }
  // }

  :deep(.r-btn[data-v-1891c10e]) {
    right: 0px;
  }

  :deep(.l-btn[data-v-1891c10e]) {
    left: 0px;
  }
}
</style>
